'use client';

import { Button } from "./ui/button";
import Link from "next/link";
import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { Loader2 } from "lucide-react";
import { ComponentProps } from "react";
import { useTranslations } from 'next-intl';

interface NavigationButtonProps extends ComponentProps<typeof Button> {
  href: string;
  children: React.ReactNode;
}

export function NavigationButton({ href, children, ...props }: NavigationButtonProps) {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const t = useTranslations('navigationButton');

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    startTransition(() => {
      router.push(href);
    });
  };

  return (
    <Button
      {...props}
      disabled={isPending}
      onClick={handleClick}
      className={`min-w-[80px] ${props.className || ''}`}
    >
      {isPending ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {t('loading')}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
